import React, { PropsWithChildren } from 'react';

import { Icon } from '@column/column-ui-kit';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@column/ui';

interface TableActionDropdownProps {
  label?: string;
}

export const TableActionDropdown: React.FC<PropsWithChildren<TableActionDropdownProps>> = ({
  label = 'Options',
  children,
}) => (
  <div className="flex justify-end" onClick={(event) => event.stopPropagation()}>
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="muted" size="icon-xs" aria-label={label} className="group shadow-none">
          <Icon.Dots className="transition-transform duration-200 [--icon-size:20px] group-data-[state=open]:rotate-90" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={4} className="min-w-48">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
);
